import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';
import { Container } from '../../Container/Container';

const Footer = () => {
  return (
    <div className={styles.Footer}>
      <Container className={styles.content}>
        <div className={styles.left}>
          <div className={styles.bottom}>
            <span className={styles.copyright}>
              © {new Date().getFullYear()} СЕБ-Восток
            </span>
            <Link to="/contact" className={styles.link}>
              Связаться с нами
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
